module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "menuzone"
    }
  }, [_c('ul', {
    staticClass: "menu"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('li', {
      class: [{
        'open selected activeSelected': item.path === _vm.$route.path.replace(/(\/\w+)\/$/, '$1')
      }, {
        first: index === 0
      }, {
        last: index === (_vm.items.length - 1)
      }]
    }, [_c('router-link', {
      attrs: {
        "to": item.path
      }
    }, [_c('span', [_c('span', [_vm._v(_vm._s(item.name))])])])], 1)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06d4d496"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fragments/AppMenu.vue
// module id = 72
// module chunks = 0